import styled, { css } from 'styled-components';
import {
  Caption as SharedCaption,
  CircleStage,
  Phrase as SharedPhrase,
  Translation as SharedTranslation,
  riseIn,
} from 'src/apps/Path/pathCelebrationStyles';

export const BannerWrap = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s3};
  `,
);

export const Stage = styled(CircleStage)`
  width: 55%;
  max-width: 220px;
  animation: ${riseIn} 0.4s ease-out 0.3s both;

  > * {
    width: 100%;
    height: 100%;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0;
  }
`;

export const Caption = styled(SharedCaption)`
  animation: ${riseIn} 0.4s ease-out 0.4s both;
`;

export const Phrase = SharedPhrase;
export const Translation = SharedTranslation;
